import React, { useState } from "react";
import {
  FaWhatsapp,
  FaTiktok,
  FaInstagram,
  FaFacebook,
} from "react-icons/fa";
import { Link } from "react-router-dom";

const Footer = () => {
  const [email, setEmail] = useState("");

  const handleSubscribe = (e) => {
    e.preventDefault();
    if (!email.trim()) return;
    window.open(
      `https://wa.me/250787255672?text=${encodeURIComponent(
        `Hi KBL Coffee — please add me to the newsletter: ${email}`
      )}`,
      "_blank"
    );
    setEmail("");
  };

  return (
    <footer className="bg-espresso-deep text-cream">
      <div className="mx-auto max-w-7xl px-5 py-14 md:px-8 lg:px-10">
        <div className="grid gap-10 sm:grid-cols-2 lg:grid-cols-5">
          <div className="space-y-4 lg:col-span-1">
            <img
              src="/kbl-logo-white.png"
              alt="KBL Coffee"
              className="h-14 w-auto object-contain"
            />
            <p className="max-w-xs text-sm leading-relaxed text-cream/75">
              Specialty coffee from Rwanda—ethically sourced, women-empowered, and
              roasted with purpose.
            </p>
            <div className="flex gap-4 pt-2 text-xl">
              <a href="https://www.instagram.com/kbl.coffee/" target="_blank" rel="noopener noreferrer" className="hover:text-gold" aria-label="Instagram">
                <FaInstagram />
              </a>
              <a href="https://www.facebook.com/" target="_blank" rel="noopener noreferrer" className="hover:text-gold" aria-label="Facebook">
                <FaFacebook />
              </a>
              <a href="https://www.tiktok.com/@kbl.coffee" target="_blank" rel="noopener noreferrer" className="hover:text-gold" aria-label="TikTok">
                <FaTiktok />
              </a>
              <a href="https://wa.me/250787255672" target="_blank" rel="noopener noreferrer" className="hover:text-gold" aria-label="WhatsApp">
                <FaWhatsapp />
              </a>
            </div>
          </div>

          <div>
            <h3 className="mb-4 font-display text-lg text-gold">Shop</h3>
            <ul className="space-y-2 text-sm text-cream/80">
              <li><Link to="/product" className="hover:text-gold">All Coffee</Link></li>
              <li><Link to="/product" className="hover:text-gold">Single Origin</Link></li>
              <li><Link to="/product" className="hover:text-gold">Gift Sets</Link></li>
              <li><Link to="/contact" className="hover:text-gold">Wholesale</Link></li>
            </ul>
          </div>

          <div>
            <h3 className="mb-4 font-display text-lg text-gold">Explore</h3>
            <ul className="space-y-2 text-sm text-cream/80">
              <li><Link to="/about" className="hover:text-gold">Our Story</Link></li>
              <li><Link to="/about" className="hover:text-gold">Farmers</Link></li>
              <li><Link to="/blog" className="hover:text-gold">Brewing Guide</Link></li>
              <li><Link to="/contact" className="hover:text-gold">Become a Distributor</Link></li>
            </ul>
          </div>

          <div>
            <h3 className="mb-4 font-display text-lg text-gold">Help</h3>
            <ul className="space-y-2 text-sm text-cream/80">
              <li><Link to="/contact" className="hover:text-gold">Shipping & Delivery</Link></li>
              <li><Link to="/contact" className="hover:text-gold">Returns</Link></li>
              <li><Link to="/contact" className="hover:text-gold">Privacy</Link></li>
              <li><Link to="/contact" className="hover:text-gold">Terms</Link></li>
            </ul>
          </div>

          <div>
            <h3 className="mb-4 font-display text-lg text-gold">Stay in the Loop</h3>
            <p className="mb-3 text-sm text-cream/70">Fresh roast news and offers.</p>
            <form onSubmit={handleSubscribe} className="flex flex-col gap-2">
              <input
                type="email"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="Your email"
                className="rounded-md border border-cream/20 bg-espresso px-3 py-2.5 text-sm text-cream outline-none placeholder:text-cream/40 focus:border-gold"
              />
              <button
                type="submit"
                className="rounded-md bg-gold px-4 py-2.5 text-sm font-semibold text-espresso transition hover:bg-gold-light"
              >
                Subscribe
              </button>
            </form>
          </div>
        </div>

        <div className="mt-12 grid gap-6 border-t border-cream/15 pt-8 md:grid-cols-2">
          <div>
            <p className="mb-3 text-xs font-semibold uppercase tracking-wider text-gold">
              Accepted Payments
            </p>
            <div className="flex flex-wrap gap-2 text-xs font-semibold text-cream/80">
              {["Visa", "Mastercard", "MoMo", "Airtel Money"].map((p) => (
                <span key={p} className="rounded border border-cream/20 px-3 py-1.5">
                  {p}
                </span>
              ))}
            </div>
          </div>
          <div>
            <p className="mb-3 text-xs font-semibold uppercase tracking-wider text-gold">
              Shipping Partners
            </p>
            <p className="text-sm text-cream/70">
              Nationwide Rwanda delivery · Regional partners on request
            </p>
          </div>
        </div>

        <div className="mt-8 flex flex-col gap-3 border-t border-cream/15 pt-6 text-sm text-cream/55 md:flex-row md:items-center md:justify-between">
          <p>
            <span className="text-gold">KBL Coffee</span> © {new Date().getFullYear()} All Rights Reserved.
          </p>
          <p className="italic">Brewed with purpose. Shared with pride.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
